import { render, staticRenderFns } from "./vue-resizable.vue?vue&type=template&id=640e10c8&scoped=true&"
import script from "./vue-resizable.vue?vue&type=script&lang=ts&"
export * from "./vue-resizable.vue?vue&type=script&lang=ts&"
import style0 from "./vue-resizable.vue?vue&type=style&index=0&id=640e10c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e10c8",
  null
  
)

export default component.exports